import { render, staticRenderFns } from "./SettingAccountForm.vue?vue&type=template&id=9987ad9e"
import script from "./SettingAccountForm.vue?vue&type=script&lang=js"
export * from "./SettingAccountForm.vue?vue&type=script&lang=js"
import style0 from "./SettingAccountForm.vue?vue&type=style&index=0&id=9987ad9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports